import { apiClient, setAuthService } from './api';
import { useAuthService } from './auth.service';

/**
 * Service for handling user-related API requests
 */
export const useUserService = () => {
  // Get auth service in component context and set it for API client
  const authService = useAuthService();
  setAuthService(authService);

  /**
   * Get the authenticated user's profile
   * @returns {Promise<Object>} User profile data
   */
  const getUserProfile = async () => {
      const response = await apiClient.get('/user');
      return response.data;
  };

  /**
   * Update the authenticated user's profile
   * @param {Object} userData - Updated user data
   * @param {String} userData.firstName - User's first name
   * @param {String} userData.lastName - User's last name
   * @param {Object} userData.contactInformation - User's contact information
   * @param {String} userData.contactInformation.address - User's address
   * @param {String} userData.contactInformation.city - User's city
   * @param {String} userData.contactInformation.country - User's country
   * @param {String} userData.contactInformation.postalCode - User's postal code
   * @returns {Promise<Object>} Updated user profile
   */
  const updateUserProfile = async (userData) => {
      const response = await apiClient.put('/user', userData);
      return response.data;
  };

  return {
    getUserProfile,
    updateUserProfile
  };
};
